import React from "react"
import styles from "../../stylesheets/typography.module.scss"
import {classNames} from "scholastic-client-components/src/SharedPackages/classnames"

export const PolicyHeader: React.FC<{small?: boolean; title: string}> = ({small, title}) => (
    <div className={styles.header}>
        <h1 className={classNames(styles.h1, small && styles.h1_smaller)}>{title}</h1>
    </div>
)
